import { render, staticRenderFns } from "./SavedPQPage.vue?vue&type=template&id=152ff038&"
import script from "./SavedPQPage.vue?vue&type=script&lang=js&"
export * from "./SavedPQPage.vue?vue&type=script&lang=js&"
import style0 from "./SavedPQPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports